module.exports = __webpack_public_path__ + "img/en-mb-banner.edc45ee3.gif";